module.exports = __webpack_public_path__ + "static/img/CAROLINA-MAPLE.5057309.png";


//////////////////
// WEBPACK FOOTER
// ./static/materials/cortina/CAROLINA-MAPLE.png
// module id = mSEL
// module chunks = 0